export { ColorsPalette as BeesafeColorsPalette } from './tenants/beesafe/colors.palette';
export { theme as beesafeTheme } from './tenants/beesafe/theme';
export { ColorsPalette as BenefiaColorsPalette } from './tenants/benefia/colors.palette';
export { theme as benefiaTheme } from './tenants/benefia/theme';
export { ColorsPalette as CompensaColorsPalette } from './tenants/compensa/colors.palette';
export { theme as compensaTheme } from './tenants/compensa/theme';
export { ANIMATIONS, BREAKPOINTS, MEDIA_QUERY } from './utils/index';
